import { Type as IconType } from '@ui/components/Icon/Icon.interfaces';
import { Variant } from '@ui/components/Notification/Notification.interfaces';

export enum NotificationType {
    EarnStamps = 'EarnStamps',
    RedeemNight = 'RedeemNight',
    NotEligible = 'NotEligible',
}

export interface NotificationData {
    variant: Variant;
    icon: IconType;
    title: string;
}
